'use client';

import { Stack, Typography } from '@mui/material';

import { StepContainer } from '@/components/wizard/StepContainer';
import type { StepProps } from '@/components/wizard/StepProps';

import type { AddCatalogWizardState } from '../addCatalogWizardState';

export const CatalogReviewStep = (props: StepProps<AddCatalogWizardState>) => {
  const {
    catalogType,
    catalogName,
    region,
    connectorExternalId,
    biglakeCatalogId,
    biglakeLocation,
    icebergUri,
    icebergWarehouse,
    icebergAuthType,
    icebergCredentialsSecretArn,
  } = props.wizardState;

  const isGlue = catalogType === 'GLUE_CATALOG';
  const isIceberg = catalogType === 'ICEBERG_REST_CATALOG';

  return (
    <StepContainer
      stepperIndex={props.stepperLabels.length - 1}
      stepperLabels={props.stepperLabels}
      canGoNext={() => true}
      nextButtonText='Create Catalog'
      backButtonText='Back'
      onBackClick={props.back}
      onNextClick={async () => {
        await props.finish();
      }}
    >
      <Stack gap='32px' padding='24px 40px'>
        <Stack gap='16px'>
          <Typography variant='subtitle2' fontWeight={700}>
            Review Catalog Details
          </Typography>
          <ReviewRow label='Catalog Name' value={catalogName} />
          <ReviewRow
            label='Catalog Type'
            value={
              isIceberg
                ? 'Iceberg REST'
                : isGlue
                  ? 'AWS Glue'
                  : 'Google BigLake'
            }
          />
          {isIceberg ? (
            <>
              <ReviewRow label='REST URI' value={icebergUri} />
              <ReviewRow label='Warehouse' value={icebergWarehouse} />
              <ReviewRow label='Auth Type' value={icebergAuthType} />
              {icebergCredentialsSecretArn && (
                <ReviewRow
                  label='Secret ARN'
                  value={icebergCredentialsSecretArn}
                />
              )}
              <ReviewRow label='AWS Account' value={connectorExternalId} />
            </>
          ) : isGlue ? (
            <>
              <ReviewRow label='Region' value={region} />
              <ReviewRow label='AWS Account' value={connectorExternalId} />
            </>
          ) : (
            <>
              <ReviewRow label='Catalog ID' value={biglakeCatalogId} />
              <ReviewRow label='Location' value={biglakeLocation} />
              <ReviewRow label='GCP Project' value={connectorExternalId} />
            </>
          )}
        </Stack>
      </Stack>
    </StepContainer>
  );
};

const ReviewRow = ({ label, value }: { label: string; value: string }) => (
  <Stack direction='row' gap='16px'>
    <Typography
      variant='body2'
      color='text.secondary'
      sx={{ minWidth: '120px' }}
    >
      {label}
    </Typography>
    <Typography variant='body2'>{value}</Typography>
  </Stack>
);
